<template>
  <div :class="container_class" :style="container_style">
    <loading
      :active="loading"
      :can-cancel="false"
      loader="dots"
      color="#2292ef"
      :is-full-page="false"
    ></loading>
    <div :class="div_class" v-for="(b, index) in budgets" :key="index" :style="div_style">
      <label :class="label_class" :style="label_style" :for="'budget-' + b.id">{{ b.title }}</label>
      <input
        :class="input_class"
        :style="input_style"
        :id="'budget-' + b.id"
        :value="b.id"
        type="radio"
        v-model="budget_id"
      />
      <hr :class="hr_class" :style="hr_style" />
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "budget",
  components: { Loading },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    container_class: {
      type: [String],
      default: ""
    },
    container_style: {
      type: [String],
      default: "display:flex;flex-flow:column;"
    },
    div_class: {
      type: [String],
      default: ""
    },
    div_style: {
      type: [String],
      default: "margin-left:10px;"
    },
    label_class: {
      type: [String],
      default: ""
    },
    label_style: {
      type: [String],
      default: ""
    },
    input_class: {
      type: [String],
      default: ""
    },
    input_style: {
      type: [String],
      default: ""
    },
    hr_class: {
      type: [String],
      default: ""
    },
    hr_style: {
      type: [String],
      default: ""
    }
  },

  data() {
    return {
      loading: false,
      budgets: [],
      budget: null,
      budget_id: null
    };
  },
  created() {
    let self = this;
    self.loading = true;
    axios({
      method: "get",
      url: "/api/v1/budget/all"
    })
      .then(function(response) {
        self.loading = false;
        if (response.data.ok) {
          self.budgets = response.data.data;
        }
      })
      .catch(function(err) {
        self.loading = false;
        console.log(err);
      });
  },
  watch: {
    budget_id: {
      handler() {
        this.$emit("input", this.budget_id);
        // if (this.budget) {
        //   this.$emit("getBudget", this.budget);
        // }
      }
    },
    value: {
      immediate: true,
      handler() {
        if (this.value != null && this.value != undefined && this.value != "") {
          let self = this;
          self.loading = true;

          axios({
            method: "get",
            url: "/api/v1/budget/" + self.value + "/show"
          })
            .then(function(response) {
              self.loading = false;
              if (response.data.ok) {
                self.budget = response.data.data;
                self.budget_id = response.data.data.id;
                self.$emit("getBudget", self.budget);
              }
            })
            .catch(function(err) {
              self.loading = false;
              console.log(err);
            });
        }
      }
    }
  }
};
</script>
